import request from '@/utils/request'
//地址
export const getCompanyList = () => request.get('/official/contactUs/company')
//地址
export const getContactTeamList = () => request.get('/official/contactUs/team')

